(function() {
'use strict';

angular
    .module('core')
    .config(($provide, $httpProvider) => {
    const codesToRetry = [500, 503, 12152, 12002, 12031, 12029, 12030, 12041, 12019, 444];

    $provide.factory('retryInterceptor', ($injector, $q) => ({
        responseError(resp) {
            if (codesToRetry.indexOf(resp.status) >= 0 &&
                resp.config.headers['x-auto-retry'] == null) {
                resp.config.headers['x-auto-retry'] = resp.status;
                const $http = $injector.get('$http');
                return $http(resp.config);
            }

            return $q.reject(resp);
        }
    }));

    if ($httpProvider.interceptors.indexOf('retryInterceptor') < 0) {
        $httpProvider.interceptors.push('retryInterceptor');
    }
});
})();
